import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Button from "@/components/ui/Button";
import Dialog from "@/components/ui/Dialog";
import Alert from "@/components/ui/Alert";
import Switch from "@/components/ui/Switch";

const GlobalComponents = {
  install(Vue) {
    Vue.component("vuePerfectScrollbar", VuePerfectScrollbar);
    Vue.component("uiButton", Button);
    Vue.component("uiSwitch", Switch);
    Vue.component("uiDialog", Dialog);
    Vue.component("uiAlert", Alert);
  }
};

export default GlobalComponents;
